import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TwcProgressBarSize, TwcProgressBarType } from '@topcon/twc-angular';

/**
 * Component to show a progress bar with a title and a optional close button
 */
@Component({
    selector: 'cw-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false,
})
export class ProgressBarComponent {
    /** Progress current value */
    @Input() progressStatus = 0;
    /** Title */
    @Input() title = '';
    /** Shows the close button or not */
    @Input() isClosable = true;
    /** Height of the twc bar */
    @Input() height: TwcProgressBarSize = 'xl';
    /** Option to wether show a top divider or not */
    @Input() showDivider = false;
    /** Show the indeterminate progress bar style */
    @Input() isIndeterminate = false;
    /** Show or hide the internal loader */
    @Input() showLoader = true;
    /** Show or hide percentage value */
    @Input() isPercentageVisible = false;
    /** Indicate type of current status */
    @Input() type: TwcProgressBarType = 'warning';

    /** Event that emits when the close button is clicked */
    @Output() closeClick = new EventEmitter<void>();

    /* istanbul ignore next*/
    onCloseClicked(): void {
        this.closeClick.emit();
    }
}
